import React from "react";

export default function HealthFitnessCertificateForm({
  formData,
  onChange,
  isViewOnly = false,
  editingFormId,
  shouldDisableField,
  getFieldStyle
}) {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  const isDisabled = (fieldName, fieldValue) => {
    if (shouldDisableField) return shouldDisableField("healthFitnessCertificate", fieldName, fieldValue);
    if (isViewOnly) return true;
    const patientInfoFields = ["name", "cprNumber"];
    return patientInfoFields.includes(fieldName);
  };

  const getStyle = (fieldName, fieldValue) => {
    if (getFieldStyle) return getFieldStyle("healthFitnessCertificate", fieldName, fieldValue);
    if (isDisabled(fieldName, fieldValue) && !isViewOnly) {
      return { backgroundColor: "#e9ecef", cursor: "not-allowed" };
    }
    return {};
  };

  return (
    <div className="row g-3">
      {/* Personal Details Section */}
      <div className="col-12">
        <table className="table table-bordered table-sm">
          <thead className="table-light">
            <tr>
              <th colSpan="2" className="text-center">Personal Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-semibold" width="30%">Name</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.patientName}
                  onChange={(e) => handleChange("name", e.target.value)}
                  disabled={isDisabled("name", formData.patientName)}
                  style={getStyle("name", formData.patientName)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">CPR Number</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.cprNumber}
                  onChange={(e) => handleChange("cprNumber", e.target.value)}
                  disabled={isDisabled("cprNumber", formData.cprNumber)}
                  style={getStyle("cprNumber", formData.cprNumber)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Profession</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.profession}
                  onChange={(e) => handleChange("profession", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Facility Name</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.performedByName}
                  onChange={(e) => handleChange("facilityName", e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Test and Examination Table */}
      <div className="col-12 mt-3">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th width="20%">Test</th>
              <th width="15%">Positive</th>
              <th width="15%">Negative</th>
              <th width="25%">Examination</th>
              <th width="25%">Findings</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-semibold">HIV1-HIV2</td>
              <td>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hiv1Hiv2"
                    checked={formData.hiv1Hiv2 === "Positive"}
                    onChange={() => handleChange("hiv1Hiv2", "Positive")}
                  />
                </div>
              </td>
              <td>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hiv1Hiv2"
                    checked={formData.hiv1Hiv2 === "Negative"}
                    onChange={() => handleChange("hiv1Hiv2", "Negative")}
                  />
                </div>
              </td>
              <td>
                <small className="d-block">Blood Pressure</small>
              </td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.bloodPressure}
                  onChange={(e) => handleChange("bloodPressure", e.target.value)}
                  placeholder="e.g., 120/80"
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">HbsAg</td>
              <td>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hbsag"
                    checked={formData.hbsag === "Positive"}
                    onChange={() => handleChange("hbsag", "Positive")}
                  />
                </div>
              </td>
              <td>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hbsag"
                    checked={formData.hbsag === "Negative"}
                    onChange={() => handleChange("hbsag", "Negative")}
                  />
                </div>
              </td>
              <td>
                <small className="d-block">Random Blood Sugar</small>
              </td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.randomBloodSugar}
                  onChange={(e) => handleChange("randomBloodSugar", e.target.value)}
                  placeholder="e.g., 95 mg/dL"
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">HCV</td>
              <td>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hcv"
                    checked={formData.hcv === "Positive"}
                    onChange={() => handleChange("hcv", "Positive")}
                  />
                </div>
              </td>
              <td>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="hcv"
                    checked={formData.hcv === "Negative"}
                    onChange={() => handleChange("hcv", "Negative")}
                  />
                </div>
              </td>
              {/* <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.hcvExamination || ''}
                  onChange={(e) => handleChange("hcvExamination", e.target.value)}
                  placeholder="Enter examination"
                />
              </td> */}
              {/* <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.hcvFindings || ''}
                  onChange={(e) => handleChange("hcvFindings", e.target.value)}
                  placeholder="Enter findings"
                />
              </td> */}
            </tr>
          </tbody>
        </table>
      </div>

      {/* TB Screening Table */}
      <div className="col-12 mt-3">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th colSpan="3" className="text-center">TB Screening</th>
            </tr>
            <tr>
              <th width="40%">TB Screening</th>
              <th width="30%">Positive</th>
              <th width="30%">Negative</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-semibold">PPD Reading (number is needed) or IGRA</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.ppdReading}
                  onChange={(e) => handleChange("ppdReading", e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.igra}
                  onChange={(e) => handleChange("igra", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Chest-xray (If required)</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder=""
                  value={formData.chestXray}
                  onChange={(e) => handleChange("chestXray", e.target.value)}
                />
              </td>
              <td colSpan="2">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder=""
                  value={formData.chestXrayNegative}
                  onChange={(e) => handleChange("chestXrayNegative", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td colSpan="3" className="text-center fst-italic">
                **TB Screening as per guideline
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Physical Examination Table */}
      <div className="col-12 mt-3">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th width="30%">Physical Examination</th>
              <th width="35%">Normal</th>
              <th width="35%">Abnormal</th>
            </tr>
          </thead>
          <tbody>
            {/* General */}
            <tr>
              <td className="fw-semibold align-middle">General</td>
              <td className="text-center align-middle">
                <div className="form-check d-flex justify-content-center mb-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="physicalGeneral"
                    checked={formData.physicalGeneral === "Normal"}
                    onChange={() => handleChange("physicalGeneral", "Normal")}
                  />
                </div>
              </td>
              <td className="align-middle">
                <div className="d-flex align-items-center gap-2">
                  <div className="form-check mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="physicalGeneral"
                      checked={formData.physicalGeneral === "Abnormal"}
                      onChange={() => handleChange("physicalGeneral", "Abnormal")}
                    />
                  </div>
                  {/* {formData.physicalGeneral === "Abnormal" && (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.physicalGeneralAbnormal || ''}
                      onChange={(e) => handleChange("physicalGeneralAbnormal", e.target.value)}
                      placeholder="Describe abnormality"
                    />
                  )} */}
                </div>
              </td>
            </tr>

            {/* Chest */}
            <tr>
              <td className="fw-semibold align-middle">Chest</td>
              <td className="text-center align-middle">
                <div className="form-check d-flex justify-content-center mb-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="physicalChest"
                    checked={formData.physicalChest === "Normal"}
                    onChange={() => handleChange("physicalChest", "Normal")}
                  />
                </div>
              </td>
              <td className="align-middle">
                <div className="d-flex align-items-center gap-2">
                  <div className="form-check mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="physicalChest"
                      checked={formData.physicalChest === "Abnormal"}
                      onChange={() => handleChange("physicalChest", "Abnormal")}
                    />
                  </div>
                  {/* {formData.physicalChest === "Abnormal" && (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.physicalChestAbnormal || ''}
                      onChange={(e) => handleChange("physicalChestAbnormal", e.target.value)}
                      placeholder="Describe abnormality"
                    />
                  )} */}
                </div>
              </td>
            </tr>

            {/* Heart */}
            <tr>
              <td className="fw-semibold align-middle">Heart</td>
              <td className="text-center align-middle">
                <div className="form-check d-flex justify-content-center mb-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="physicalHeart"
                    checked={formData.physicalHeart === "Normal"}
                    onChange={() => handleChange("physicalHeart", "Normal")}
                  />
                </div>
              </td>
              <td className="align-middle">
                <div className="d-flex align-items-center gap-2">
                  <div className="form-check mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="physicalHeart"
                      checked={formData.physicalHeart === "Abnormal"}
                      onChange={() => handleChange("physicalHeart", "Abnormal")}
                    />
                  </div>
                  {/* {formData.physicalHeart === "Abnormal" && (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.physicalHeartAbnormal || ''}
                      onChange={(e) => handleChange("physicalHeartAbnormal", e.target.value)}
                      placeholder="Describe abnormality"
                    />
                  )} */}
                </div>
              </td>
            </tr>

            {/* Abdomen */}
            <tr>
              <td className="fw-semibold align-middle">Abdomen</td>
              <td className="text-center align-middle">
                <div className="form-check d-flex justify-content-center mb-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="physicalAbdomen"
                    checked={formData.physicalAbdomen === "Normal"}
                    onChange={() => handleChange("physicalAbdomen", "Normal")}
                  />
                </div>
              </td>
              <td className="align-middle">
                <div className="d-flex align-items-center gap-2">
                  <div className="form-check mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="physicalAbdomen"
                      checked={formData.physicalAbdomen === "Abnormal"}
                      onChange={() => handleChange("physicalAbdomen", "Abnormal")}
                    />
                  </div>
                  {/* {formData.physicalAbdomen === "Abnormal" && (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.physicalAbdomenAbnormal || ''}
                      onChange={(e) => handleChange("physicalAbdomenAbnormal", e.target.value)}
                      placeholder="Describe abnormality"
                    />
                  )} */}
                </div>
              </td>
            </tr>

            {/* Others */}
            <tr>
              <td className="fw-semibold align-middle">Others (Specify)</td>
              <td className="text-center align-middle">
                <div className="form-check d-flex justify-content-center mb-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="physicalOthers"
                    checked={formData.physicalOthers === "Normal"}
                    onChange={() => handleChange("physicalOthers", "Normal")}
                  />
                </div>
              </td>
              <td className="align-middle">
                <div className="d-flex align-items-center gap-2">
                  <div className="form-check mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="physicalOthers"
                      checked={formData.physicalOthers === "Abnormal"}
                      onChange={() => handleChange("physicalOthers", "Abnormal")}
                    />
                  </div>
                  {/* {formData.physicalOthers === "Abnormal" && (
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={formData.physicalOthersAbnormal || ''}
                      onChange={(e) => handleChange("physicalOthersAbnormal", e.target.value)}
                      placeholder="Describe abnormality"
                    />
                  )} */}
                </div>
              </td>
            </tr>

            {/* Referral (Keeping text box as it's separate) */}
            <tr>
              <td className="fw-semibold align-middle">Referral</td>
              <td colSpan="2" className="align-middle">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Required or Not required"
                  value={formData.referral}
                  onChange={(e) => handleChange("referral", e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Health Declaration */}
      <div className="col-12 mt-3">
        <div className="border p-2">
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={formData.healthDeclaration}
              onChange={(e) => handleChange("healthDeclaration", e.target.checked)}
            />
            <label className="form-check-label small">
              I declare that there are no health problems or illness (physical or mental) which may in a way restrict the professional's ability to practice safely as a health professional.
            </label>
          </div>
        </div>
      </div>

      {/* Vaccination Table */}
      <div className="col-12 mt-3">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th width="30%">Vaccination</th>
              <th width="70%">Completed or not completed</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-semibold">Comments</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={formData.vaccinationComments}
                  onChange={(e) => handleChange("vaccinationComments", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td colSpan="2" className="text-center fst-italic small">
                **Vaccination according to Guideline for Vaccination of health care workers (MOH)
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Certificate Declaration */}
      <div className="col-12 mt-3">
        <div className="border p-2">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              checked={formData.certificateDeclaration}
              onChange={(e) => handleChange("certificateDeclaration", e.target.checked)}
            />
            <label className="form-check-label small">
              I declare that the information given in this certificate is completed and correct.
            </label>
          </div>
        </div>
      </div>

      {/* Examination Performed By Table */}
      <div className="col-12 mt-3">
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th colSpan="2" className="text-center">Examination Performed by</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fw-semibold" width="30%">Name</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.performedByName}
                  onChange={(e) => handleChange("performedByName", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">License Number</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.licenseNumber}
                  onChange={(e) => handleChange("licenseNumber", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Category</td>
              <td>
                <input
                  type="text"
                  className="form-control form-control-sm border-0"
                  value={formData.category}
                  onChange={(e) => handleChange("category", e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-semibold">Date & Time</td>
              <td>
                <input
                  type="datetime-local"
                  className="form-control form-control-sm border-0"
                  value={formData.examinationDate}
                  onChange={(e) => handleChange("examinationDate", e.target.value)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
